import React, { useState } from "react";
import { Button, Avatar, Menu, Dropdown, Tooltip, Alert, Badge } from "antd";
import { LogoutOutlined, UserOutlined, QuestionCircleOutlined, DownOutlined, CopyOutlined, CheckOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import toast from "react-hot-toast";
import defaultAvatar from "../assets/images/avatar.png";
import { getAppNameByUsername } from "../modules/auth/services/tokenApp";
import "./css/navbar.css";
 
const { Header } = require("antd/lib/layout/layout");
 
const NavBar = () => {
  const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));
  const username = currentUser?.user?.username;
  const userId = currentUser?.userId;
  const kycVerified = currentUser.kycVerified;
  // const redirectUrl = 'http://localhost:3000/dashboard';
  // const notifyUrl = `http://192.168.1.10:6002/merchant-service/api/v1/merchants/kyc-status/${userId}`;
  const role = currentUser?.roles;
  const isAdmin = role && role.includes("ADMIN");
 
  const { data: tokens = [] } = useQuery(
    ["appNameByUser", username],
    () => getAppNameByUsername(username),
    { enabled: !!username }
  );
 
  const firstToken = tokens.length > 0 ? tokens[0]?.token : null;
 
  const [copied, setCopied] = useState(false);
 
  const handleCopyToken = async () => {
    if (!firstToken) {
      toast.error("Aucune clé disponible ! Tu peux en créer dans Mon profil");
      return;
    }
    try {
      await navigator.clipboard.writeText(firstToken);
      setCopied(true);
      toast.success("Votre première clé a été copiée !");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Erreur lors de la copie");
    }
  };
 
  const userMenu = (
    <Menu>
      <div className="text-center me-4">
        <Avatar size={35} src={currentUser?.user?.fileName || defaultAvatar} />
      </div>
      <p className="user-name-center">
        <strong>{currentUser?.user?.firstName} {currentUser?.user?.lastName}</strong>
      </p>
      <p className="user-email-center">{currentUser?.user?.email}</p>
      <Menu.Item key="profile"icon={<UserOutlined />}>
        <Link to="/profile-admin">Mon profil</Link>
      </Menu.Item>
      <Menu.Item key="help" icon={<QuestionCircleOutlined />}>
        Aide
      </Menu.Item>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <Link to="/logout">Se déconnecter</Link>
      </Menu.Item>
    </Menu>
  );
 
  return (
    <Header className="navbar-header-admin">
      <div className="token-container-admin">
        {firstToken && (
          <Tooltip title={copied ? "Clé copiée !" : "Cliquer pour copier"}>
            <Button
              type="default"
              icon={copied ? <CheckOutlined /> : <CopyOutlined />}
              size="small"
              onClick={handleCopyToken}
              className={copied ? "copied-button" : "token-button"}
                >
              {copied ? "Clé copiée aves succès" : "Votre clé API"}
            </Button>
          </Tooltip>
        )}
      </div>
      {
        !kycVerified && !isAdmin &&(
          <Alert
            message={
              <span>
                Confirmer votre identité en quelques minutes,
                <a href={`${process.env.REACT_APP_KYC}?notify_url=${process.env.REACT_APP_NOTIFY_URL}${userId}&&redirect_url=${process.env.REACT_APP_REDIRECT_URL}`}
                style={{ marginLeft: '5px', textDecoration: 'underline' }}>
                  cliquez ici
                </a>
              </span>
            }
            type="info"
            className="mx-auto d-flex align-items-center w-45"
            showIcon
          />)
      }
      <div className="navbar-right-admin">
        {/* <Badge count={0} overflowCount={99}>
            <BellOutlined style={{ fontSize: 24, color: "#1890ff", cursor: "pointer" }} />
          </Badge> */}
        <Dropdown overlay={userMenu} trigger={['click']}>
          <div className="avatar-name-admin">
            <Badge dot={true} className={kycVerified ? 'green-dot' : 'red-dot'}>
              <Avatar  size={35} src={currentUser?.user?.fileName || defaultAvatar} />
            </Badge>
              <span className="nameProfil-admin">
              {currentUser?.user?.firstName} {currentUser?.user?.lastName} <DownOutlined />
              </span>
          </div>
        </Dropdown>
      </div>
    </Header>
  );
};
 
export default NavBar;